// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__2U5k2","navbarMain":"NavBar_navbarMain__dFqCn","link":"NavBar_link__kzh1w"};